import { graphql } from '@/generated/gql';

export const DEMAND_CONVERSATION_SETTINGS_QUERY = graphql(/* GraphQL */ `
  query DemandConversationSettingsQuery($entityId: UUID!, $entityVariant: SvbrgConversationEntityVariant!) {
    sevenbridges {
      conversationSettings(entityId: $entityId, entityVariant: $entityVariant) {
        id
        entityId
        entityVariant
        tools {
          id
          isEnabled
        }
        quickActions {
          id
          prompt
          translations {
            id
            language
            text
            variant
          }
          isConversationStarter
        }
        createdAt
        updatedAt
      }
    }
  }
`);
